import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Steps } from "antd";
import {
    CheckCircleFilled,
    ExclamationCircleFilled,
} from "@ant-design/icons";
import "./nujobsdashboardApplyCheck.scss";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";

function NuJobsApplyCheck() {

  const navigate = useNavigate();
 const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
 const { myResumes,profileCompleted } = useNuJobDetailsStore();  

  return (
    <div className="nujobsdashboardapplycheck-wrapper">
    <div className="apply-check-title">
        Before Applying for Jobs
        <div>
          <Steps
              size="small"
              current={-1}
              items={[
                  {
                      title: (
                          <span
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate("/nujobshome/nujobsMyResumes")}
                          >
                              Upload Resume
                          </span>
                      ),
                      description:  myResumes?.filter((item) => item.resumestatus != "NO_RES")?.length > 0 ? "Completed" : "Action Required",
                      status: myResumes?.filter((item) => item.resumestatus != "NO_RES")?.length > 0 ? "finish" : "wait",
                      icon: myResumes?.filter((item) => item.resumestatus != "NO_RES")?.length > 0
                          ? <CheckCircleFilled style={{ color: "#52c41a" }} />
                          : <ExclamationCircleFilled style={{ color: "#ff4d4f" }} />,
                  },
                  {
                      title: (
                          <span
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate("/nujobshome/nujobsCandidateProfile")}
                          >
                              Complete Profile
                          </span>
                      ),
                      description: profileCompleted>60 ? "Completed" : "Action Required",
                      status: profileCompleted>60 ? "finish" : "wait",
                      icon: profileCompleted>60
                          ? <CheckCircleFilled style={{ color: "#52c41a" }} />
                          : <ExclamationCircleFilled style={{ color: "#ff4d4f" }} />,
                  },
              ]}
          />    
        </div>
    
    </div>

    </div>
  );
}

export default NuJobsApplyCheck;